import { Skeleton } from '@mui/material';
import { Stack } from '@mui/system';
import { randomAlphabetString } from '@utils/random';
import { FunctionComponent } from 'react';

export type TableSkeletonProps = {
  rows: number;
};

export const TableSkeleton: FunctionComponent<TableSkeletonProps> = (props) => {
  const { rows } = props;

  return (
    <Stack spacing={1}>
      <Skeleton animation="wave" variant="rounded" height={60} />
      {Array.from({ length: rows }).map(() => (
        <Skeleton
          animation="wave"
          key={randomAlphabetString(5)}
          variant="rounded"
          height={53}
        />
      ))}
      <Skeleton animation="wave" variant="rounded" height={40} />
    </Stack>
  );
};
